import './media-queries.css';

export default {};
